import type { EnterpriseCloudCatalogInitData } from "@ext/enterprise-cloud/types/EnterpriseCloudCatalogInitData";

export class EnterpriseCloudApi {
	constructor(private _gesCloudUrl: string) {}

	async getCatalogInitData(): Promise<EnterpriseCloudCatalogInitData> {
		const res = await fetch(`${this._gesCloudUrl}/enterprise-cloud/catalog/get-init-data`, {
			credentials: "include",
		});
		if (!res.ok) throw new Error(`Failed to get catalog init data: ${res.statusText}`);
		return await res.json();
	}
}
